import hide_routers from "@/router/hide_routers"
var SIGN_REGEXP = /([yMdhsm])(\1*)/g;
var DEFAULT_PATTERN = "yyyy-MM-dd";

function padding(s, len) {
  len = len - (s + "").length;
  for (var i = 0; i < len; i++) {
    s = "0" + s;
  }
  return s;
}
export default {
  // 获取动态路由
  getRoutes: data => {
    // 菜单解析
    const menus = [];
    for (const menu of data) {
      if (menu.children) {
        for (const child of menu.children) {
          menus.push(child);
        }
      } else {
        menus.push(menu);
      }
    }
    // 路由解析
    let routes = [
      {
        path: "/",
        name: "Layouts",
        redirect: "/",
        component: () => import("@/layouts"),
        children: []
      }
    ];
    for (const route of menus) {
      routes[0]["children"].push({
        path: route.path,
        name: route.compName,
        component: () => import(`@/views${route.compPath}`),
        meta: {
          keepAlive: true,
          keepAliveUse: false
        }
      });
      if (route.children && route.children.length > 0){
        for (const subRoute of route.children){
          routes[0]["children"].push({
            path: subRoute.path,
            name: subRoute.compName,
            component: () => import(`@/views${subRoute.compPath}`),
            meta: {
              keepAlive: true,
              keepAliveUse: false
            }
          });
        }
      }
    }
    routes[0]["children"] = [...routes[0]["children"], ...hide_routers]
    return routes;
  },
  // 日期格式解析
  formatDate: {
    format: function(date, pattern) {
      if (typeof date == 'string') {
        return date;
      }
      pattern = pattern || DEFAULT_PATTERN;
      return pattern.replace(SIGN_REGEXP, function($0) {
        switch ($0.charAt(0)) {
          case "y":
            return padding(date.getFullYear(), $0.length);
          case "M":
            return padding(date.getMonth() + 1, $0.length);
          case "d":
            return padding(date.getDate(), $0.length);
          case "w":
            return date.getDay() + 1;
          case "h":
            return padding(date.getHours(), $0.length);
          case "m":
            return padding(date.getMinutes(), $0.length);
          case "s":
            return padding(date.getSeconds(), $0.length);
        }
      });
    },
    parse: function(dateString, pattern) {
      var matchs1 = pattern.match(SIGN_REGEXP);
      var matchs2 = dateString.match(/(\d)+/g);
      if (matchs1.length === matchs2.length) {
        var _date = new Date(1970, 0, 1);
        for (var i = 0; i < matchs1.length; i++) {
          var _int = parseInt(matchs2[i]);
          var sign = matchs1[i];
          switch (sign.charAt(0)) {
            case "y":
              _date.setFullYear(_int);
              break;
            case "M":
              _date.setMonth(_int - 1);
              break;
            case "d":
              _date.setDate(_int);
              break;
            case "h":
              _date.setHours(_int);
              break;
            case "m":
              _date.setMinutes(_int);
              break;
            case "s":
              _date.setSeconds(_int);
              break;
          }
        }
        return _date;
      }
      return null;
    },
  },
  checkIsMobile(){
    return navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i)
  },
  // 参数列表 :
  //title: confirm为true时, 可传参自定义标题
  // type: ['edit', 'delete'],
  // callback: 回调方法,
  // confirm: 是否需要二次确认(true/false)
  operatorBtn_FORMAT: function(h, params, ...btns) {
    let temp = [];
    btns.forEach(item => {
      if (item.confirm === undefined) {
        return;
      }
      var typeFormatter = flag => {
        switch (flag) {
          case "edit":
            return "md-create";
          case "delete":
            return "md-trash";
          default:
            return ""; //默认按钮
        }
      };
      var nameFormatter = row => {
        switch (row.type) {
          case "edit":
            return "编辑";
          case "delete":
            return "删除";
          default:
            return row.name ? row.name: ""; //默认按钮
        }
      };
      if (item.type === 'switch'){
        let func1 = h("i-Switch", {
          props: {
            'true-value': 1,
            'false-value': 2,
            value: item.value,
            'before-change':()=>item.callback(params.row, params.index, (params.row[item.paramName] == 1 ? 2 : 1))
          },
          style: {
            marginTop: "-2px",
            marginRight: "4px"
          },
        });
        temp.push(func1);
      }else {
        if (!item.confirm) {
          let func1 = h(
            "a",
            {
              style: {
                marginRight: "16px"
              },
              on: {
                click: () => item.callback(params.row,params.index)
              }
            },
            [
              h("Icon", {
                props: {
                  type: typeFormatter(item.type),
                  size: 16
                },
                style: {
                  marginTop: "-2px",
                  marginRight: "4px"
                }
              }),
              nameFormatter(item)
            ]
          );
          temp.push(func1);
        } else {
          let func1 = h(
            "Poptip",
            {
              props: {
                confirm: true,
                transfer: true,
                title: item.title === undefined ? "是否确定删除?" : item.title,
                "ok-text": "是",
                "cancel-text": "否"
              },
              on: {
                "on-ok": () => item.callback(params.row,params.index)
              }
            },
            [
              h("a", [
                h("Icon", {
                  props: {
                    type: typeFormatter(item.type),
                    size: 16
                  },
                  style: {
                    marginTop: "-2px",
                    marginRight: "4px"
                  }
                }),
                nameFormatter(item)
              ])
            ]
          );
          temp.push(func1);
        }
      }
    });
    return h("div", temp);
  },
  //图片转换
  dataURLtoBlob(dataurl) {
    let arr = dataurl.split(','),
      mime = arr[0].match(/:(.*?);/)[1],
      bstr = atob(arr[1]),
      n = bstr.length,
      u8arr = new Uint8Array(n);
    while (n--) {
      u8arr[n] = bstr.charCodeAt(n);
    }
    return new Blob([u8arr], { type: mime });
  },
   async getBase64 (url, callback) {
    var Img = new Image(),
      dataURL = '';
    Img.crossOrigin = "*"
    Img.setAttribute('crossOrigin', 'Anonymous');
    Img.onload = () => {
       let canvas = document.createElement("canvas"),
         width = Img.width,
         height = Img.height;
       canvas.width = width;
       canvas.height = height;
       canvas.getContext("2d").drawImage(Img, 0, 0, width, height);
       let ext = Img.src.substring(Img.src.lastIndexOf('.') + 1).toLowerCase()
       dataURL = canvas.toDataURL('image/' + ext);
       callback ? callback(dataURL) : null;
     }
     Img.src = url +"?v=" + Math.random();
   },
  //base 转file
  /**
   * @param base64  base64数据
   * @param filename 文件名称,可自定义,传空则默认设置为:   时间+.jpeg
   * @param contentType 文件类型
   * @param index 文件索引,用于错开时间执行
   * */
  translateBase64ImgToFile(base64,filename,contentType,index){
    return  new Promise((reslove)=>{
      setTimeout(()=>{
        if (!filename){
          filename =  `${new Date().getTime()}.jpeg`;
        }
        // console.log( `上传索引${index}图片${new Date().getTime()}.jpeg`)
        let arr = base64.split(',')  //去掉base64格式图片的头部
        let bstr = atob(arr[1])   //atob()方法将数据解码
        let leng = bstr.length
        let u8arr = new Uint8Array(leng)
        while(leng--){
          u8arr[leng] =  bstr.charCodeAt(leng) //返回指定位置的字符的 Unicode 编码
        }
        reslove(new File([u8arr],filename,{type:contentType}))
      },100*index)
    })
  }
};
